import Timeago from './timeago.vue';
export default Timeago;


// WEBPACK FOOTER //
// ./src/components/timeago/index.js